// extracted by mini-css-extract-plugin
module.exports = {"filterItemContainer":"SearchDropdown_filterItemContainer__1mBXd","filterType":"SearchDropdown_filterType__L08fl","closeIcon":"SearchDropdown_closeIcon__20UBg"};